import { Autocomplete, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, ImageList, ImageListItem, ImageListItemBar, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { Fragment, useState } from 'react'
import { getEOCActive } from '../../../reducer/eocActiveSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../../reducer/profileSlice';
import { getActivityConfig } from '../../../reducer/activityConfigSlice';
import dayjs from "dayjs";
import CustomDatePicker from '../ComponentReuse/CustomDatePicker';
import { LoadingButton } from '@mui/lab';
import ResponseDialog from '../ComponentReuse/ResponseDialog';
import { setEOCHistory } from '../../../reducer/eocHistorySlice';
import { setActivityActive } from '../../../reducer/activityActiveSlice';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { getWeekOfYear } from '../../../function/WOY';

function AddActivity({ open, setOpen, notOpenEOC }) {

    const theme = useTheme();
    const [fullWidth, setFullWidth] = useState(true);
    const eocActive = useSelector(getEOCActive);
    const profile = useSelector(getProfile);
    const activityConfig = useSelector(getActivityConfig);
    const [activityName, setActivityName] = useState([]);
    const [activityDes, setActivityDes] = useState("");
    const [image, setImage] = useState([]);
    const [activityDate, setActivityDate] = useState(null);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);
    const [loading, setLoading] = useState(false);
    const [eocReason, setEocReason] = useState("");
    const dispatch = useDispatch();
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only('sm'));
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.only('md'));
    const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    const getCols = () => {
        if (isSmallScreen) return 2; // สำหรับหน้าจอ sm
        if (isMediumScreen) return 3; // สำหรับหน้าจอ md
        if (isLargeScreen) return 4; // สำหรับหน้าจอ lg ขึ้นไป
        return 1; // สำหรับหน้าจอขนาดเล็กกว่า sm
    };

    const handleClose = () => {
        setActivityName([]);
        setActivityDes("");
        setImage([]);
        setActivityDate(null);
        setStatus("");
        setModalResponse(false);
        setEocReason("");
        setOpen(false);
    };

    const handleDate = (value) => {
        if (value) {
            setActivityDate(value.valueOf());
        }
    };

    const callMyEOCData = async () => {
        try {
            let param = "";
            if (profile?.org_level === "02") {
                param = `org_id=${profile?.org_id}`;
            } else {
                param = `area_code=${profile?.area_code}`;
            }
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_eoc/${profile?.org_level}?${param}`
            );
            const data = await response.json();
            if (data.history_eoc.length !== 0) {
                dispatch(setEOCHistory(data?.history_eoc.reverse()));
            } else {
                dispatch(setEOCHistory(undefined));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const callActivityData = async (eoc_id) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_activity/${eoc_id}`
            );
            const data = await response.json();
            if (data.length !== 0) {
                dispatch(setActivityActive(data));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getEOCDataTitle = () => {
        let data = "ระดับ";
        if (profile?.org_level === "01") {
            data += "ประเทศ ";
        } else if (profile?.org_level === "02") {
            data += "เขต " + profile.org_name;
        } else if (profile?.org_level === "03") {
            data += "จังหวัด " + profile.province_name;
        } else if (profile?.org_level === "04") {
            data +=
                "อำเภอ " +
                profile.amphur_name +
                " จังหวัด" +
                profile.province_name +
                "";
        }
        return data;
    };

    const getEOCDataTitleEOC = () => {
        let data = "ระดับ";
        if (eocActive?.org_level === "01") {
            data += "ประเทศ ";
        } else if (eocActive?.org_level === "02") {
            data += "เขต " + eocActive.org_name;
        } else if (eocActive?.org_level === "03") {
            data += "จังหวัด " + eocActive.province_name;
        } else if (eocActive?.org_level === "04") {
            data +=
                "อำเภอ " +
                eocActive.amphur_name +
                " จังหวัด" +
                eocActive.province_name +
                "";
        }
        return data;
    };

    const startEOC = () => {
        const timeStamp = eocActive?.start_eoc_timestamp;
        const date = new Date(parseInt(timeStamp));
        const startDate = dayjs(date);
        return startDate;
    };

    const handleActivityDes = (e) => {
        setActivityDes(e.target.value);
    };

    const resizeImage = (image, targetWidth, targetHeight) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = image;
            img.onload = () => {
                let width = img.width;
                let height = img.height;
                let scale = 1;
                if (width > targetWidth || height > targetHeight) {
                    const scaleWidth = targetWidth / width;
                    const scaleHeight = targetHeight / height;
                    scale = Math.min(scaleWidth, scaleHeight);
                }

                width *= scale;
                height *= scale;

                // create image with canvas 720 p
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                // return as base 64
                resolve(canvas.toDataURL("image/png"));
            };
        });
    };

    const handleImage = async (e) => {
        const img = e.target.files;
        const imgList = [];
        if (img.length + image.length <= 20) {
            for (let index = 0; index < img.length; index++) {
                const element = img[index];
                if ((element && element.type === 'image/png') || (element && element.type === 'image/jpg') || (element && element.type === 'image/jpeg')) {
                    const imgDataUrl = await resizeImage(
                        URL.createObjectURL(element),
                        1280,
                        720
                    );
                    imgList.push(imgDataUrl);
                } else {
                    setStatus("กรุณาเลือกไฟล์ที่มีนามสกุล .png และ .jpg เท่านั้น")
                    setModalResponse(true)
                    break;
                }
            }
            setImage((prev) => {
                return [...prev, ...imgList];
            });
        } else {
            setStatus("คุณใส่รูปเกินที่กำหนด");
            setModalResponse(true);
        }
    };

    const handleCloseResponse = () => {

        setModalResponse(false);
        if (
            Object.keys(activityName).length !== 0 &&
            Object.keys(activityDes).length !== 0 &&
            (activityDate !== undefined || activityDate !== null)
        ) {
            // eocReason : สาเหตุที่ไม่เปิด EOC
            if (eocReason !== undefined && eocReason !== "") {
                callMyEOCData();
                setOpen(false);
            } else {
                if (!notOpenEOC) {
                    callActivityData(eocActive.eoc_id);
                    setOpen(false);
                }
            }
        }
    };

    const onDeleteImage = async (index) => {
        let newImage = [...image];
        newImage.splice(index, 1);
        setImage(newImage);
    };

    const getWOY = () => {
        let woy = { week: "", year: "" };
        let getWOY = getWeekOfYear(dayjs(activityDate).toDate());
        woy.week = getWOY.week;
        woy.year = getWOY.year;
        return woy;
    };

    const handleNotEOC = (e) => {
        setEocReason(e.target.value);
    };

    const handleUploadImage = async () => {
        let image_link = [];
        for (let index = 0; index < image.length; index++) {
            const element = image[index];
            const imageBase64 = element.replace("data:image/png;base64,", "");
            const optionImageUpload = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ base64data: imageBase64 }),
            };
            const uploadResponse = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/upload_img_base64`,
                optionImageUpload
            );
            if (uploadResponse.ok) {
                const data = await uploadResponse.json();
                image_link.push(data.image.file);
            } else {
                console.error(uploadResponse)
            }
        }
        return image_link;
    };

    const handleSubmit = async () => {
        setLoading(true);
        if (eocActive !== undefined) {
            try {
                if (
                    activityName.length !== 0 &&
                    activityDes.length !== 0 &&
                    (activityDate !== undefined || activityDate !== null)
                ) {
                    const image_link = await handleUploadImage();
                    let dataSend = {
                        eoc_id: eocActive?.eoc_id,
                        activity: activityName,
                        description: activityDes,
                        image_link: image_link,
                        creator_id: eocActive?.creator_id,
                        creator_name: eocActive?.creator_name,
                        org_id: profile?.org_id,
                        org_name: profile?.org_name,
                        org_type: profile?.org_type,
                        org_type_name: profile?.org_type_name,
                        org_level: profile?.org_level,
                        org_level_name: profile?.org_level_name,
                        create_timestamp: activityDate.valueOf().toString(),
                        phone: profile?.telephone,
                        email: profile?.mail,
                    };
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}/my_eoc/create_activity`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(dataSend),
                        }
                    );
                    if (response.ok) {
                        setStatus("ทำการเปิดกิจกรรมเสร็จสิ้น");
                        setModalResponse(true);
                    } else {
                        setStatus("ไม่สามารถเปิดกิจกรรมได้");
                        setModalResponse(true);
                    }
                } else {
                    let request = "ใส่ข้อมูล";
                    if (activityName.length === 0) {
                        request += " ชื่อกิจกรรม";
                    }
                    if (activityDate === undefined || activityDate === null) {
                        request += " วันที่";
                    }
                    if (activityDes.length === 0) {
                        request += " รายละเอียดกิจกรรม";
                    }
                    setStatus((request += "ไม่ครบ"));
                    setModalResponse(true);
                }
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        } else {
            try {
                if (
                    (eocReason !== undefined && eocReason !== "") &&
                    activityName.length !== 0 &&
                    activityDes.length !== 0 &&
                    (activityDate !== undefined || activityDate === null)
                ) {
                    const image_link = await handleUploadImage();
                    let dataSend = {
                        ep_timestamp: activityDate.toString(),
                        ep_week: getWOY().week,
                        ep_year: getWOY().year,
                        activity: activityName,
                        description: activityDes,
                        image_link: image_link,
                        creator_id: profile?.inum,
                        creator_name: profile?.displayName,
                        province_code: profile?.province_code,
                        province_name: profile?.province_name,
                        amphur_code: profile?.amphur_code,
                        amphur_name: profile?.amphur_name,
                        tambon_code: profile?.tambon_code,
                        tambon_name: profile?.tambon_name,
                        area_code: profile?.area_code,
                        org_id: profile?.org_id,
                        org_name: profile?.org_name,
                        org_type: profile?.org_type,
                        org_type_name: profile?.org_type_name,
                        org_level: profile?.org_level,
                        org_level_name: profile?.org_level_name,
                        phone: profile?.telephone,
                        email: profile?.mail,
                        remark: eocReason,
                    };
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}/my_eoc/create_activity_wo_eoc`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(dataSend),
                        }
                    );
                    if (response.ok) {
                        setStatus(
                            "ทำการเปิดรายงานการดำเนินการตอบโต้ภาวะฉุกเฉิน โดยไม่เปิดEOC เสร็จสิ้น"
                        );
                        setModalResponse(true);
                    } else {
                        setStatus(
                            "ไม่สามารถเปิดรายงานการดำเนินการตอบโต้ภาวะฉุกเฉิน โดยไม่เปิดEOC ได้"
                        );
                        setModalResponse(true);
                    }
                } else {
                    let request = "";
                    if (eocReason.length === 0) {
                        request += "เหตุผล ";
                    }
                    if (activityName.length === 0) {
                        request += "ชื่อกิจกรรม ";
                    }
                    if (activityDate === undefined || activityDate === null) {
                        request += "วันที่ ";
                    }
                    if (activityDes.length === 0) {
                        request += "รายละเอียดกิจกรรม ";
                    }

                    setStatus("ใส่ข้อมูล " + request + " ไม่ครบ");
                    setModalResponse(true);
                }
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        }
    };

    return (
        <Fragment>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={'lg'}
                open={open}
            >
                <DialogTitle className='py-3'>
                    <div>
                        {eocActive === undefined ? (
                            <div>
                                <Typography variant="body1">
                                    รายงานการดำเนินกิจกรรมตอบโต้ภาวะฉุกเฉิน
                                </Typography>
                                <Typography variant="body2">{getEOCDataTitle()}</Typography>
                            </div>
                        ) : (
                            <div>
                                <Typography variant="body1">เพิ่มกิจกรรม</Typography>
                                <Typography variant="body2">
                                    กิจกรรมระหว่างเปิด EOC {getEOCDataTitleEOC()}{" "}
                                </Typography>
                            </div>
                        )}
                    </div>
                </DialogTitle>
                <DialogContent className='md:px-16' dividers>
                    <div className="w-full items-center mt-4 mb-4 grid gap-2 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        {eocActive === undefined ? (
                            <>
                                <Typography className="col-span-1 w-full">เหตุผลที่ไม่เปิด EOC</Typography>
                                <div className="col-span-9 w-full">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        fullWidth
                                        value={eocReason}
                                        onChange={handleNotEOC}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                        <Typography className="col-span-1 w-full">
                            ชื่อกิจกรรม
                        </Typography>
                        <Autocomplete
                            multiple
                            fullWidth
                            className="col-span-9 w-full overflow-auto"
                            id="autocomplete-multiple-chips"
                            options={activityConfig?.config || []}
                            value={activityName}
                            getOptionLabel={(option) => option}
                            onChange={(event, newValue) => {
                                setActivityName(newValue);
                            }}
                            renderTags={(value, getTagProps) =>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        maxWidth: '100%',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {value.map((option, index) => (
                                        <Chip
                                            key={index}
                                            label={option}
                                            {...getTagProps({ index })}
                                        />
                                    ))}
                                </Box>
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    placeholder="เลือกกิจกรรม"
                                    className='w-full'
                                />
                            )}
                        />
                    </div>

                    <div className="w-full items-center mb-4 grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        <Typography className="col-span-1 w-full">วันที่</Typography>
                        <div className="col-span-9 w-full items-center">
                            <CustomDatePicker
                                className='max-w-[300px]'
                                minDate={eocActive !== undefined ? startEOC() : dayjs()}
                                value={activityDate}
                                onChange={handleDate}
                                slotProps={{
                                    textField: { size: "small", fullWidth }
                                }}
                            />
                        </div>
                    </div>

                    <div className="w-full items-center mb-4 grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        <Typography className="col-span-1 w-full">รายละเอียด</Typography>
                        <div className="col-span-9 w-full">
                            <TextField
                                id="outlined-multiline-details"
                                label=""
                                fullWidth
                                multiline
                                rows={4}
                                value={activityDes}
                                onChange={handleActivityDes}
                            />
                        </div>
                    </div>

                    <div className="w-full items-center mb-4 grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        <Typography className="col-span-1 w-full">ภาพกิจกรรม</Typography>
                        <div className="col-span-9 w-full flex items-center">
                            <Button
                                disabled={image.length === 20 ? true : false}
                                variant="outlined"
                                size='small'
                                component="label"
                                style={{
                                    color: "#cd6c4a",
                                    borderColor: "#cd6c4a"
                                }}
                            >
                                เพิ่มรูปภาพกิจกรรม
                                <input type="file" accept=".png, .jpg, .jpeg" onChange={handleImage} multiple />
                            </Button>
                            <Typography variant="subtitle2" sx={{ marginLeft: "10px" }}>{image.length}/20</Typography>
                        </div>
                    </div>

                    <div>
                        <ImageList
                            sx={{
                                width: '100%',
                                overflow: 'hidden',
                            }}
                            cols={getCols()}
                            gap={8}
                        >
                            {image.map(((data, index) => (
                                <ImageListItem
                                    key={index}
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                >
                                    <img
                                        src={data}
                                        loading="lazy"
                                        className="w-full h-auto"
                                    />
                                    {hoveredIndex === index && (
                                        <ImageListItemBar
                                            sx={{ height: '30px' }}
                                            actionIcon={
                                                <IconButton
                                                    className={
                                                        `absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${hoveredIndex === index ? 'block' : 'hidden'}`
                                                    }
                                                    sx={{
                                                        color: 'rgba(255, 255, 255, 0.7)',
                                                        transition: '0.5s',
                                                    }}
                                                    aria-label={`delete`}
                                                    onClick={() => onDeleteImage(index)}
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            }
                                        />
                                    )}
                                </ImageListItem>
                            )))}
                        </ImageList>
                    </div>

                </DialogContent>
                <DialogActions className='m-4 gap-[10px]'>
                    <LoadingButton
                        loading={loading}
                        onClick={handleSubmit}
                        variant="contained"
                        size='small'
                        style={{
                            backgroundColor: "#cd6c4a",
                        }}
                    >
                        บันทึกกิจกรรม
                    </LoadingButton>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        size='small'
                        style={{
                            color: "#000",
                            borderColor: "#ccc",
                        }}
                    >ปิด</Button>
                </DialogActions>
            </Dialog>
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />
        </Fragment>
    )
}

export default AddActivity